/**
 * SparkLayer Address Validation Hook — Sheesh B2B
 * Offizielle SparkLayer-API: window.sparkOptions.onCheckoutValidation
 * (Nicht die alte oncheckoutvalidation auf window.sparklayer — die existiert in v4 nicht mehr.)
 *
 * Modus: SOFT (zeigt Warnung) — Hard-Mode blockiert Checkout über returntes errors[].
 *        HARD an: window.SL_ADDRESS_VALIDATION_HARD = true vor diesem Script.
 */
(function () {
  'use strict';
  var VERSION = '2026-05-15-v10';
  var DEBUG = !!window.SL_ADDR_VAL_DEBUG;
  if (DEBUG) console.log('[SheeshAddrVal] script version ' + VERSION + ' loaded');

  var BRIDGE_BASE = 'https://bridge.webagentur-twopixels.de';
  var ENDPOINT_VALIDATE = BRIDGE_BASE + '/api/bridge/validate-address';
  var ENDPOINT_LOG      = BRIDGE_BASE + '/api/bridge/validate-address/log';
  var TIMEOUT_MS = 6000;
  // Tenant-Key: kann pro Kunde im theme.liquid überschrieben werden
  //   <script>window.TP_TENANT_KEY = 'sheesh';</script>  vor diesem Hook
  var TENANT_KEY = window.TP_TENANT_KEY || 'sheesh';
  var HARD_DEFAULT = true;  // Hard-Mode aktiv: blockt Checkout bei invalid Adresse

  function hard() {
    return window.SL_ADDRESS_VALIDATION_HARD !== false && (HARD_DEFAULT || !!window.SL_ADDRESS_VALIDATION_HARD);
  }

  // Schließbarer Toast unten-rechts.
  // Bleibt bis User korrigiert oder X klickt.
  var BANNER_ID = 'twopixels-addr-validation-banner';

  function showBanner(title, body) {
    var el = document.getElementById(BANNER_ID);
    if (!el) {
      el = document.createElement('div');
      el.id = BANNER_ID;
      el.setAttribute('role', 'alert');
      el.style.cssText = [
        'position:fixed', 'bottom:20px', 'right:20px',
        'width:380px', 'max-width:calc(100vw - 40px)',
        'z-index:2147483646',
        'background:#fff', 'color:#222',
        'border-left:6px solid #c41616',
        'border-radius:6px',
        'padding:14px 36px 14px 16px',
        'font-family:system-ui,-apple-system,sans-serif',
        'font-size:14px', 'line-height:1.45',
        'box-shadow:0 6px 24px rgba(0,0,0,0.25)',
        'box-sizing:border-box'
      ].join(';');

      var close = document.createElement('button');
      close.setAttribute('type', 'button');
      close.setAttribute('aria-label', 'Schließen');
      close.textContent = '×';
      close.style.cssText = 'position:absolute;top:6px;right:8px;background:none;border:none;font-size:22px;line-height:1;cursor:pointer;color:#666;padding:4px';
      close.onclick = function () { el.style.display = 'none'; };
      el.appendChild(close);

      var inner = document.createElement('div');
      inner.className = 'twopixels-addr-banner-content';
      el.appendChild(inner);

      document.body && document.body.appendChild(el);
    }
    var inner = el.querySelector('.twopixels-addr-banner-content');
    inner.innerHTML = '';
    var t = document.createElement('div');
    t.style.cssText = 'font-weight:600;color:#c41616;margin-bottom:6px;font-size:15px';
    t.textContent = '⚠ ' + title;
    var b = document.createElement('div');
    b.style.cssText = 'color:#333;font-size:13px';
    b.textContent = body;
    inner.appendChild(t);
    inner.appendChild(b);
    el.style.display = 'block';
  }
  function hideBanner() {
    var el = document.getElementById(BANNER_ID);
    if (el) el.style.display = 'none';
  }

  // SparkLayer rendert customCheckoutValidationErrors als <div class="bg-warn-bg ...">
  // mit nur einem <svg-warn> drin — kein Text. Wir füllen das selbst.
  var INJECTED_CLASS = 'twopixels-warn-content';
  var lastError = null;   // { description, title, body }

  function findEditButtonForAddress(description) {
    if (!description) return null;
    // Liste der Adressen im Cart-Drawer (oder Account-Bereich)
    var items = document.querySelectorAll('li');
    for (var i = 0; i < items.length; i++) {
      var li = items[i];
      var p = li.querySelector('p');
      if (p && p.textContent && p.textContent.indexOf(description) !== -1) {
        var btn = li.querySelector('button[title="Adresse bearbeiten"], button[aria-label="Adresse bearbeiten"]');
        if (btn) return btn;
      }
    }
    return null;
  }

  // Sucht alle Elemente passend zu einem Selektor, INKLUSIVE Shadow Roots
  function deepQueryAll(root, selector) {
    var out = [];
    function walk(node) {
      if (!node) return;
      if (node.querySelectorAll) {
        var matches = node.querySelectorAll(selector);
        for (var i = 0; i < matches.length; i++) out.push(matches[i]);
        // Alle Elemente mit shadowRoot rekursiv
        var all = node.querySelectorAll('*');
        for (var j = 0; j < all.length; j++) {
          if (all[j].shadowRoot) walk(all[j].shadowRoot);
        }
      }
    }
    walk(root);
    return out;
  }

  function injectIntoNativeWarn() {
    if (!lastError) return;
    var selector = 'div.bg-warn-bg, div[class*="bg-warn-bg"], div[class*="border-warn"], div[class*="warn-bg"], svg-warn';
    var warns = deepQueryAll(document, selector);
    // Wenn nur svg-warn gefunden → das ist nur das Icon, wir wollen den Container (parent div)
    warns = warns.map(function (el) {
      if (el.tagName && el.tagName.toLowerCase() === 'svg-warn') {
        var p = el.closest('div.bg-warn-bg, div[class*="warn-bg"], div[class*="border-warn"]');
        return p || el.parentElement && el.parentElement.parentElement;
      }
      return el;
    }).filter(function (el, idx, arr) {
      return el && arr.indexOf(el) === idx;  // unique
    });

    if (DEBUG) {
      console.log('[SheeshAddrVal] injectIntoNativeWarn: found',
        warns.length, 'warn elements; lastError:', lastError && lastError.title);
      // Plus: erstes warn-Element komplett dumpen
      if (warns.length === 0) {
        // Diagnostik: welche svg-warn / *warn* gibt es überhaupt?
        var anyWarn = deepQueryAll(document, '[class*="warn"], svg-warn, [class*="alert"]');
        console.log('[SheeshAddrVal] DIAG: any *warn*/alert elements in DOM:', anyWarn.length);
        if (anyWarn.length > 0) {
          console.log('[SheeshAddrVal] DIAG sample classes:',
            anyWarn.slice(0, 5).map(function (e) { return e.tagName + '.' + (e.className || '(no class)'); }));
        }
      }
    }
    for (var i = 0; i < warns.length; i++) {
      var w = warns[i];
      // Skip wenn schon unsere injection drin
      if (w.querySelector('.' + INJECTED_CLASS)) continue;
      // textContent ohne SVG-Inhalt prüfen
      var clone = w.cloneNode(true);
      var svgs = clone.querySelectorAll('svg, svg-warn');
      for (var s = 0; s < svgs.length; s++) svgs[s].remove();
      var hasText = (clone.textContent || '').trim().length > 0;
      if (DEBUG) {
        console.log('[SheeshAddrVal] warn-el #' + i + ' classes=' + w.className +
          ' hasText=' + hasText + ' (innerText="' + (clone.textContent || '').trim().slice(0, 40) + '")');
      }
      if (hasText) continue;

      var box = document.createElement('div');
      box.className = INJECTED_CLASS;
      box.style.cssText = 'flex:1;color:#7a0d0d;font-size:13px;line-height:1.5';

      var t = document.createElement('div');
      t.style.cssText = 'font-weight:600;margin-bottom:4px;font-size:14px';
      t.textContent = lastError.title;

      var b = document.createElement('div');
      b.style.cssText = 'margin-bottom:8px';
      b.textContent = lastError.body;

      var actions = document.createElement('div');
      actions.style.cssText = 'display:flex;gap:8px;flex-wrap:wrap;margin-top:6px';

      var btnFix = document.createElement('button');
      btnFix.type = 'button';
      btnFix.textContent = '✎ Adresse korrigieren';
      btnFix.style.cssText = 'background:#c41616;color:#fff;border:none;border-radius:4px;padding:6px 12px;font-size:13px;font-weight:500;cursor:pointer';
      btnFix.onclick = function () {
        var editBtn = findEditButtonForAddress(lastError.description);
        if (editBtn) { editBtn.click(); return; }
        // Fallback: zu Account-Adressen navigieren
        window.location.href = '/account/addresses';
      };

      var btnAccount = document.createElement('a');
      btnAccount.href = '/account/addresses';
      btnAccount.textContent = 'Alle Adressen verwalten';
      btnAccount.style.cssText = 'color:#c41616;text-decoration:underline;font-size:13px;align-self:center';

      actions.appendChild(btnFix);
      actions.appendChild(btnAccount);

      box.appendChild(t);
      box.appendChild(b);
      box.appendChild(actions);

      // In das flex-container einfügen (neben dem svg-warn icon)
      var flex = w.querySelector('.flex.gap-x-2') || w;
      flex.appendChild(box);
    }
  }

  // Beobachte das DOM — sobald SparkLayer das leere Warn-Feld einfügt, füllen wir.
  // Reicht ein MutationObserver: kein Polling-Interval (das spammt die Konsole).
  var domObserver = null;
  function ensureObserver() {
    if (domObserver) return;
    var pending = false;
    domObserver = new MutationObserver(function () {
      if (pending || !lastError) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        injectIntoNativeWarn();
      });
    });
    if (document.body) {
      domObserver.observe(document.body, { childList: true, subtree: true });
      if (DEBUG) console.log('[SheeshAddrVal] DOM observer attached');
    }
  }

  function logTelemetry(event, payload, result) {
    try {
      fetch(ENDPOINT_LOG, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          event: event, payload: payload, result: result,
          tenant_key: TENANT_KEY, ts: Date.now()
        })
      }).catch(function () {});
    } catch (_) {}
  }

  // SparkLayer v4: cart.customerAddresses = [{id, description}],
  // cart.deliveryAddressId = ausgewählte ID.
  function extractAddress(cart) {
    if (!cart || typeof cart !== 'object') return null;
    var addrs = cart.customerAddresses;
    var id = cart.deliveryAddressId;
    if (!Array.isArray(addrs) || !id) return null;
    var selected = addrs.find(function (a) { return a && a.id === id; });
    if (!selected) return null;
    return {
      description: selected.description || '',
      country: 'DE',
      addressId: selected.id
    };
  }

  async function validate(cart) {
    var addr = extractAddress(cart);
    if (DEBUG) {
      try {
        var allKeys = cart ? Object.keys(cart) : [];
        console.log('[SheeshAddrVal] ALL cart keys (' + allKeys.length + '):', allKeys.join(', '));
        // Snapshot aller potentiell adress-bezogenen Properties
        var snapshot = {};
        allKeys.forEach(function (k) {
          if (/addr|deliv|ship|locat|customer|recipient|consign/i.test(k)) {
            snapshot[k] = cart[k];
          }
        });
        console.log('[SheeshAddrVal] address-related fields:', JSON.stringify(snapshot, null, 2));
        // Plus alle 23 Keys mit ihren TOP-LEVEL Werten (truncated)
        var fullSnap = {};
        allKeys.forEach(function (k) {
          var v = cart[k];
          if (v === null || typeof v !== 'object') {
            fullSnap[k] = v;
          } else if (Array.isArray(v)) {
            fullSnap[k] = '[Array len=' + v.length + ']';
          } else {
            fullSnap[k] = '{Object keys=' + Object.keys(v).slice(0, 8).join(',') + '}';
          }
        });
        console.log('[SheeshAddrVal] cart shape:', fullSnap);
      } catch (e) { console.log('[SheeshAddrVal] log err:', e); }
      try { console.log('[SheeshAddrVal] extracted address:', addr); } catch (_) {}
    }
    if (!addr || !addr.description) {
      logTelemetry('skipped_incomplete', addr, null);
      return null;
    }

    try {
      var resp = await fetch(ENDPOINT_VALIDATE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(addr),
        signal: (typeof AbortSignal !== 'undefined' && AbortSignal.timeout)
          ? AbortSignal.timeout(TIMEOUT_MS) : undefined
      });
      if (!resp.ok) { logTelemetry('bridge_unreachable_status', addr, { status: resp.status }); return null; }

      var result = await resp.json();
      if (result && result.valid === false) {
        var reasonText = {
          address_not_found: ' Straße, PLZ oder Ort scheinen nicht zu existieren.',
          postcode_mismatch: ' Die PLZ passt nicht zum Ort.',
          city_mismatch: ' Die Stadt passt nicht zur PLZ.'
        }[result.reason] || ' Bitte prüfe Straße, PLZ und Ort.';
        var msg = 'Die angegebene Lieferadresse konnte nicht verifiziert werden ('
                + addr.description + ').' + reasonText;
        var title = hard() ? 'Lieferadresse ungültig' : 'Lieferadresse fragwürdig';
        var body = msg + (hard()
          ? ' Der Checkout ist blockiert bis du die Adresse korrigierst.'
          : ' (Hinweis-Modus — Checkout läuft trotzdem.)');
        lastError = { description: addr.description, title: title, body: body };
        ensureObserver();
        injectIntoNativeWarn();
        showBanner(title, body);
        if (hard()) {
          logTelemetry('hard_block', addr, result);
          return [msg];
        } else {
          logTelemetry('soft_warn', addr, result);
          console.warn('[SheeshAddrVal] would block:', msg, result);
          return null;
        }
      }
      logTelemetry('valid', addr, result);
      lastError = null;
      hideBanner();
      // Bereits injizierte Warn-Content wieder entfernen
      var injected = document.querySelectorAll('.' + INJECTED_CLASS);
      for (var k = 0; k < injected.length; k++) injected[k].remove();
      return null;
    } catch (e) {
      logTelemetry('error', addr, { error: (e && e.message) || String(e) });
      hideBanner();  // fail-open auch fürs UI
      console.warn('[SheeshAddrVal] skipped:', e && e.message);
      return null;
    }
  }

  // Wrap existing onCheckoutValidation, falls Kunde später eigenen Hook setzt
  function wrap(existing) {
    return async function (cart) {
      var ours = await validate(cart);
      var theirs = null;
      if (typeof existing === 'function') {
        try { theirs = await existing(cart); } catch (e) { console.error('[SheeshAddrVal] inner hook err:', e); }
      }
      if (ours && theirs && Array.isArray(theirs) && Array.isArray(ours)) return theirs.concat(ours);
      return ours || theirs || null;
    };
  }

  // Pre-Init: Hook in sparkOptions setzen (vor spark.js)
  window.sparkOptions = window.sparkOptions || {};
  var preexisting = window.sparkOptions.onCheckoutValidation;
  window.sparkOptions.onCheckoutValidation = wrap(preexisting);

  // Zusätzlich: onCartUpdate — feuert NACH jedem Cart-Update (auch Adress-Save).
  // Damit kommt das Feedback direkt nach Save, nicht erst beim Checkout-Versuch.
  var prevOnCartUpdate = window.sparkOptions.onCartUpdate;
  window.sparkOptions.onCartUpdate = async function (cart, results) {
    try { await validate(cart); } catch (e) { console.warn('[SheeshAddrVal] onCartUpdate err:', e); }
    if (typeof prevOnCartUpdate === 'function') {
      try { return await prevOnCartUpdate(cart, results); } catch (e) {}
    }
  };

  console.log('[SheeshAddrVal] installed in sparkOptions (onCheckoutValidation + onCartUpdate)');

  // Post-Init Fallback: warte auf window.spark und überschreibe options
  var installed = false;
  function tryInstall() {
    if (installed) return;
    if (window.spark && window.spark.options) {
      // onCheckoutValidation
      var existing = window.spark.options.onCheckoutValidation;
      if (existing !== window.sparkOptions.onCheckoutValidation) {
        window.spark.options.onCheckoutValidation = wrap(existing);
      }
      // onCartUpdate
      var existingCu = window.spark.options.onCartUpdate;
      if (existingCu !== window.sparkOptions.onCartUpdate) {
        window.spark.options.onCartUpdate = window.sparkOptions.onCartUpdate;
      }
      console.log('[SheeshAddrVal] wiring up complete (post-init)');
      installed = true;
    }
  }
  tryInstall();
  if (!installed) {
    var tries = 0;
    var poll = setInterval(function () {
      tryInstall();
      if (installed || ++tries > 80) clearInterval(poll);  // 80*250ms = 20s
    }, 250);
  }
})();
